export default "__VITE_ASSET__153b138b__"